// Silk Network theme scripts
(function() {
    'use strict';

    // Mobile hamburger menu — uses .menu-open on <body> for CSS transitions
    var hamburgerBtn = document.querySelector('.hamburger-btn');
    var closeBtn = document.querySelector('.hamburger-close');
    var mobileMenu = document.querySelector('.mobile-menu');
    var isAnimating = false;
    var ANIMATION_DURATION = 300; // matches CSS transition duration

    function openMobileMenu() {
        if (!mobileMenu || isAnimating) return;
        isAnimating = true;
        document.body.classList.add('menu-open');
        document.body.style.overflow = 'hidden';
        hamburgerBtn && hamburgerBtn.setAttribute('aria-expanded', 'true');
        mobileMenu.setAttribute('aria-hidden', 'false');
        setTimeout(function() { isAnimating = false; }, ANIMATION_DURATION);
    }

    function closeMobileMenu() {
        if (!mobileMenu || isAnimating) return;
        isAnimating = true;
        document.body.classList.remove('menu-open');
        document.body.style.overflow = '';
        hamburgerBtn && hamburgerBtn.setAttribute('aria-expanded', 'false');
        mobileMenu.setAttribute('aria-hidden', 'true');
        setTimeout(function() { isAnimating = false; }, ANIMATION_DURATION);
    }

    if (hamburgerBtn && mobileMenu) {
        hamburgerBtn.addEventListener('click', openMobileMenu);
    }
    if (closeBtn && mobileMenu) {
        closeBtn.addEventListener('click', closeMobileMenu);
    }

    // Close mobile menu on Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && mobileMenu && document.body.classList.contains('menu-open')) {
            closeMobileMenu();
            hamburgerBtn && hamburgerBtn.focus();
        }
    });

    // Close mobile menu on overlay click (click outside the nav content)
    if (mobileMenu) {
        mobileMenu.addEventListener('click', function(e) {
            // Only close if clicking the overlay background itself,
            // not the header/nav/CTA content inside
            if (e.target === mobileMenu) {
                closeMobileMenu();
            }
        });

        // Close mobile menu on nav link click
        mobileMenu.querySelectorAll('a[href]').forEach(function(link) {
            link.addEventListener('click', function() {
                closeMobileMenu();
            });
        });
    }
})();

// Header hide/show on scroll direction
// rAF-throttled. Clamps scrollY >= 0 for overscroll. Skips when mobile menu open.
(function() {
    'use strict';

    var header = document.querySelector('[data-header]');
    if (!header) return;

    var SCROLL_THRESHOLD = 80;  // px before hiding kicks in
    var TOP_THRESHOLD = 10;     // px — always visible when near top
    var ticking = false;
    var lastScrollY = window.scrollY;

    function updateHeader() {
        // Clamp for overscroll (pull-to-refresh on mobile)
        var currentScrollY = Math.max(0, window.scrollY);

        // Skip if mobile menu is open
        if (document.body.classList.contains('menu-open')) {
            ticking = false;
            return;
        }

        // Near top — always visible, no shadow
        if (currentScrollY < TOP_THRESHOLD) {
            header.classList.remove('header-hidden', 'header-scrolled', 'header-visible');
        }
        // Scrolling down past threshold — hide
        else if (currentScrollY > lastScrollY && currentScrollY > SCROLL_THRESHOLD) {
            header.classList.add('header-hidden');
            header.classList.remove('header-visible');
            header.classList.add('header-scrolled');
        }
        // Scrolling up — show
        else if (currentScrollY < lastScrollY) {
            header.classList.remove('header-hidden');
            header.classList.add('header-visible');
            if (currentScrollY > TOP_THRESHOLD) {
                header.classList.add('header-scrolled');
            } else {
                header.classList.remove('header-scrolled');
            }
        }

        lastScrollY = currentScrollY;
        ticking = false;
    }

    window.addEventListener('scroll', function() {
        if (!ticking) {
            requestAnimationFrame(updateHeader);
            ticking = true;
        }
    }, { passive: true });
})();

// Contact form — wired to AWS Lambda signup API
// Pattern adapted from silknetwork-website coming-soon page
(function() {
    'use strict';

    var form = document.getElementById('contact-form');
    if (!form) return; // Not on the contact page

    var nameInput = document.getElementById('contact-name');
    var emailInput = document.getElementById('contact-email');
    var orgInput = document.getElementById('contact-org');
    var messageInput = document.getElementById('contact-message');
    var submitBtn = document.getElementById('contact-submit-btn');
    var messageDiv = document.getElementById('contact-form-message');

    var API_URL = 'https://jow1x7y38h.execute-api.us-east-1.amazonaws.com/contact';
    var RATE_LIMIT_SECONDS = 10;
    var REQUEST_TIMEOUT_MS = 15000;
    var MAX_RETRIES = 2;

    var isSubmitting = false;
    var lastSubmitTime = 0;

    var BTN_DEFAULT_CLASSES = 'bg-primary border-2 border-primary text-navy px-8 py-3.5 rounded font-extrabold text-sm uppercase tracking-widest hover:bg-navy hover:text-white hover:border-navy transition-all w-full sm:w-auto';
    var BTN_SUCCESS_CLASSES = 'bg-green-500 border-2 border-green-500 text-white px-8 py-3.5 rounded font-extrabold text-sm uppercase tracking-widest transition-all w-full sm:w-auto cursor-default';
    var BTN_ERROR_CLASSES = 'bg-red-500 border-2 border-red-500 text-white px-8 py-3.5 rounded font-extrabold text-sm uppercase tracking-widest transition-all w-full sm:w-auto';

    function isOnline() {
        return navigator.onLine !== false;
    }

    function checkOnlineStatus() {
        if (!isOnline()) {
            showMessage('You appear to be offline. Please check your connection.', false);
            return false;
        }
        return true;
    }

    window.addEventListener('online', function() {
        hideMessage();
    });

    window.addEventListener('offline', function() {
        showMessage('You are offline. Please check your connection.', false);
    });

    function showMessage(text, isSuccess) {
        messageDiv.textContent = text;
        messageDiv.className = 'text-sm font-medium ' + (isSuccess ? 'text-green-600' : 'text-red-600');
    }

    function hideMessage() {
        messageDiv.textContent = '';
        messageDiv.className = 'hidden text-sm font-medium';
    }

    function setButtonState(text, disabled, state) {
        submitBtn.textContent = text;
        submitBtn.disabled = disabled;

        if (state === 'success') {
            submitBtn.className = BTN_SUCCESS_CLASSES;
        } else if (state === 'error') {
            submitBtn.className = BTN_ERROR_CLASSES;
        } else {
            submitBtn.className = BTN_DEFAULT_CLASSES;
        }
    }

    function getCampaignContext() {
        var params = new URLSearchParams(window.location.search || '');
        var context = {
            page: window.location.pathname || '/',
            referrer: document.referrer || ''
        };
        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function(key) {
            var value = params.get(key);
            if (value) {
                context[key] = value.substring(0, 180);
            }
        });
        return context;
    }

    function fetchWithTimeout(url, options, timeoutMs, retries) {
        var controller = new AbortController();
        var timeoutId = setTimeout(function() { controller.abort(); }, timeoutMs);

        options.signal = controller.signal;

        return fetch(url, options).then(function(response) {
            clearTimeout(timeoutId);
            return response;
        }).catch(function(error) {
            clearTimeout(timeoutId);

            if (error.name === 'AbortError') {
                throw new Error('Request timed out. Please try again.');
            }

            if (retries > 0 && isOnline()) {
                showMessage('Connection issue. Retrying...', false);
                return new Promise(function(resolve) {
                    setTimeout(resolve, 1000);
                }).then(function() {
                    return fetchWithTimeout(url, options, timeoutMs, retries - 1);
                });
            }

            throw error;
        });
    }

    form.addEventListener('submit', function(e) {
        e.preventDefault();

        if (!checkOnlineStatus()) {
            return;
        }

        if (isSubmitting) {
            return;
        }

        var now = Date.now();
        var timeSinceLastSubmit = (now - lastSubmitTime) / 1000;

        if (timeSinceLastSubmit < RATE_LIMIT_SECONDS) {
            var waitTime = Math.ceil(RATE_LIMIT_SECONDS - timeSinceLastSubmit);
            showMessage('Please wait ' + waitTime + ' seconds before trying again.', false);
            return;
        }

        var name = nameInput.value.trim();
        var email = emailInput.value.trim();
        var org = orgInput.value.trim();
        var message = messageInput.value.trim();

        if (!name) {
            showMessage('Please enter your name.', false);
            nameInput.focus();
            return;
        }

        if (!email) {
            showMessage('Please enter your email address.', false);
            emailInput.focus();
            return;
        }

        if (!message) {
            showMessage('Please enter a message.', false);
            messageInput.focus();
            return;
        }

        isSubmitting = true;
        lastSubmitTime = now;
        hideMessage();
        setButtonState('Sending...', true, null);

        var body = {
            email: email,
            source: 'contact-form',
            name: name,
            message: message
        };

        Object.assign(body, getCampaignContext());

        if (org) {
            body.org = org;
        }

        fetchWithTimeout(
            API_URL,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(body)
            },
            REQUEST_TIMEOUT_MS,
            MAX_RETRIES
        ).then(function(response) {
            return response.json();
        }).then(function(data) {
            if (data.ok) {
                setButtonState('Sent!', true, 'success');
                showMessage('Thanks for reaching out! We\'ll get back to you soon.', true);
                form.reset();

                setTimeout(function() {
                    setButtonState('Send Message', false, null);
                    hideMessage();
                }, 5000);
            } else {
                throw new Error(data.error || 'Something went wrong');
            }
        }).catch(function(error) {
            console.error('Contact form error:', error);

            var errorMsg = 'Something went wrong. Please try again.';

            if (error.message && error.message.indexOf('timed out') !== -1) {
                errorMsg = 'Connection timed out. Please check your internet and try again.';
            } else if (error.message && (error.message.indexOf('Failed to fetch') !== -1 || error.message.indexOf('NetworkError') !== -1)) {
                errorMsg = 'Unable to connect. Please check your internet connection.';
            } else if (error.message) {
                errorMsg = error.message;
            }

            setButtonState('Error — Retry', false, 'error');
            showMessage(errorMsg, false);

            setTimeout(function() {
                setButtonState('Send Message', false, null);
                hideMessage();
            }, 5000);
        }).finally(function() {
            isSubmitting = false;
        });
    });
})();

// Image loading placeholders and transient wake retry.
// Keeps cached CloudFront HTML user-friendly while Fly/Ghost wakes and images become reachable.
(function() {
    'use strict';

    var MAX_ATTEMPTS = 12;
    var RETRY_DELAYS = [1000, 2000, 3000, 5000, 8000, 8000, 10000, 10000, 10000, 10000, 10000, 10000];

    function markLoaded(shell) {
        shell.classList.add('is-loaded');
        shell.classList.remove('is-retrying', 'is-error');
    }

    function markLoading(shell) {
        shell.classList.remove('is-loaded', 'is-error');
    }

    function getImageScope(img) {
        if (img.classList.contains('silk-placeholder-card-image')) {
            return 'card';
        }
        if (img.classList.contains('silk-placeholder-page-image')) {
            return 'page';
        }
        if (img.classList.contains('kg-image')) {
            return 'article';
        }
        return null;
    }

    function enhanceImage(img) {
        if (!img || img.dataset.silkImageEnhanced === 'true') {
            return;
        }

        // Only enhance Ghost content/page/card images, not logos, avatars, or unrelated theme chrome.
        var scope = getImageScope(img);
        if (!scope) {
            return;
        }

        img.dataset.silkImageEnhanced = 'true';

        var shellClassByScope = {
            article: 'silk-image-shell--article',
            page: 'silk-image-shell--page',
            card: 'silk-image-shell--card'
        };
        var shell = document.createElement('span');
        shell.className = 'silk-image-shell ' + shellClassByScope[scope];
        shell.setAttribute('aria-live', 'polite');
        shell.setAttribute('aria-label', img.getAttribute('alt') ? 'Loading image' : 'Image loading');

        var parent = img.parentNode;
        if (!parent) {
            return;
        }
        parent.insertBefore(shell, img);
        shell.appendChild(img);

        var attempts = 0;
        var originalSrc = img.getAttribute('src') || '';
        var originalSrcset = img.getAttribute('srcset') || '';
        var originalSizes = img.getAttribute('sizes') || '';

        function retryImage() {
            if (img.complete && img.naturalWidth > 0) {
                markLoaded(shell);
                return;
            }

            if (attempts >= MAX_ATTEMPTS) {
                shell.classList.remove('is-retrying');
                shell.classList.add('is-error');
                return;
            }

            attempts += 1;
            markLoading(shell);
            shell.classList.add('is-retrying');

            var delay = RETRY_DELAYS[Math.min(attempts - 1, RETRY_DELAYS.length - 1)];
            window.setTimeout(function() {
                img.removeAttribute('srcset');
                img.removeAttribute('sizes');
                img.removeAttribute('src');

                window.requestAnimationFrame(function() {
                    if (originalSizes) {
                        img.setAttribute('sizes', originalSizes);
                    }
                    if (originalSrcset) {
                        img.setAttribute('srcset', originalSrcset);
                    }
                    if (originalSrc) {
                        img.setAttribute('src', originalSrc);
                    }
                });
            }, delay);
        }

        img.addEventListener('load', function() {
            markLoaded(shell);
        });

        img.addEventListener('error', retryImage);

        if (img.complete && img.naturalWidth > 0) {
            markLoaded(shell);
        } else {
            markLoading(shell);
        }
    }

    function initSilkImagePlaceholders() {
        document.querySelectorAll('img.kg-image, img.silk-placeholder-card-image, img.silk-placeholder-page-image').forEach(enhanceImage);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSilkImagePlaceholders);
    } else {
        initSilkImagePlaceholders();
    }
})();
